import React from 'react';

interface Props {
    children?: string | JSX.Element | JSX.Element[];
}

export const ErrorMessage = ({ children }: Props): JSX.Element => (
    <span className="font-semibold text-sm">{children}</span>
);
